// src/utils/layout/layoutConstants.js
//
// Elektrik layout sabitleri ve dokuman tanimlari.

export const INITIAL_DEFS = [
  { name: "Topraklama Hesab\u0131", w: 600, h: 1000, hasFrame: false },
  { name: "Topraklama Detaylar\u0131", w: 600, h: 1000, hasFrame: false },
  { name: "Kablo Bacas\u0131", w: 600, h: 1000, hasFrame: false },
  { name: "Gerilim D\u00fc\u015f\u00fcm\u00fc", w: 125, h: 550, hasFrame: false },
  { name: "Pano Detay", w: 250, h: 250, hasFrame: false },
  { name: "Enerji Odasi", w: 250, h: 250, hasFrame: false },
  { name: "Sembol Listesi", w: 1050, h: 1500 },
  { name: "Notlar", w: 1050, h: 1500 },
  { name: "Baslik", w: 1050, h: 1500 },
];

export const DOCUMENT_OFFSET = 50;
export const HEADER_HEIGHT = 50;

export const STANDARD_HEIGHTS = [310, 457, 620, 760, 860, 914, 1070];
export const MULTIPLIER = 5;

// OLE async mesh natural-aspect cache: doc.name -> gercek meshH
export const OLE_ACTUAL_H_CACHE = new Map();
